// function afterRender() {  
//     const productItems = document.querySelectorAll('.boost-sd__product-item');  
//     const bannerItems = document.querySelectorAll(".collection-banner-holder__item");
//     let step = 5; // Starten mit einem 5er Schritt
//     let counter = step; // Zählt die Elemente für das nächste Einfügen
//     productItems.forEach((productItem, i) => {      
//         if (i + 1 === counter) { // Prüfen, ob das aktuelle Element der nächste Einfügepunkt ist
//             productItem.innerHTML = bannerItems.item(0).innerHTML
//             if(step === 11) {
//                 productItem.style.gridColumn = "span 2"
//             }
//             step = step === 5 ? 11 : 5; // Schritt abwechselnd zwischen 5 und 10 wechseln
//             counter += step; // Nächster Einfügepunkt basierend auf dem aktuellen Schritt
//         }
//     });
// }

// window.addEventListener('load', function (event) {
//     afterRender();
// });

window.addEventListener('load', function () {
    setTimeout(function () {
        const video_banner_one = document.getElementById("video_banner_one");

        if (video_banner_one) {
            video_banner_one.muted = true;
            video_banner_one.autoplay = true;
            video_banner_one.loop = true;
            video_banner_one.load();
            video_banner_one.play().catch((error) => {
                console.error(`Video konnte nicht abgespielt werden: ${error.message}`);
            });
        }

        const video_banner_two = document.getElementById("video_banner_two");

        if (video_banner_two) {
            video_banner_two.muted = true;
            video_banner_two.autoplay = true;
            video_banner_two.loop = true;
            video_banner_two.load();
            video_banner_two.play().catch((error) => {
                console.error(`Video konnte nicht abgespielt werden: ${error.message}`);
            });
        }

        const video_banner_three = document.getElementById("video_banner_three");
        
        if (video_banner_three) {
            video_banner_three.muted = true;
            video_banner_three.autoplay = true;
            video_banner_three.loop = true;
            video_banner_three.load();
            video_banner_three.play().catch((error) => {
                console.error(`Video konnte nicht abgespielt werden: ${error.message}`);
            });
        }
    }, 600);
});